import Constant from "../Utils/Constant";
import { useState, useEffect } from 'react';

// Cadrage de la photo d'accueil (réglé dans l'admin) : « left center », etc.
const POSITION = /^(left|center|right) (top|center|bottom)$/;

const HomeSection = ({ backgroundImage, backgroundPosition, darkMode, setDarkMode }) => {

    const [currentText, setCurrentText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [wordIndex, setWordIndex] = useState(0);
    
    const words = [Constant.DEVELOPPER, Constant.TREKKER, Constant.TRAVELER];
    
    useEffect(() => {
        const timeout = setTimeout(() => {
            const currentWord = words[wordIndex];
            
            if (!isDeleting) {
                // Écriture du texte
                if (currentIndex < currentWord.length) {
                    setCurrentText(currentWord.substring(0, currentIndex + 1));
                    setCurrentIndex(currentIndex + 1);
                } else {
                    // Pause avant de commencer à effacer
                    setTimeout(() => setIsDeleting(true), 2000);
                }
            } else {
                // Effacement du texte
                if (currentIndex > 0) {
                    setCurrentText(currentWord.substring(0, currentIndex - 1));
                    setCurrentIndex(currentIndex - 1);
                } else {
                    // Passer au mot suivant
                    setIsDeleting(false);
                    setWordIndex((wordIndex + 1) % words.length);
                }
            }
        }, isDeleting ? 100 : 150);
        
        return () => clearTimeout(timeout);
    }, [currentText, currentIndex, isDeleting, wordIndex, words]);
    
    const sectionStyle = {
        // Sans image configurée : pas d'image de secours, le fond sombre du thème (theme.css)
        '--home-bg-img': backgroundImage ? `url('${backgroundImage}')` : 'none',
        '--home-bg-pos': POSITION.test(backgroundPosition || '') ? backgroundPosition : 'center center'
    };

    return (
        <section id="home" className="section home-section" style={sectionStyle}>
            <div className="home-content">
                <div className="hero-text">
                    <h1 className="name-title">{Constant.NAME}</h1>
                    <div className="typewriter-container">
                        <span className="typewriter-text">
                            <span className="dynamic-text">{currentText}</span>
                            <span className="cursor">|</span>
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HomeSection;